//
// Module for the Manual wizard's Direct Deposit tab on the Benefit Details step
//
rs.module("participant/benefit/setup/manual/wizard/benefitdetailstabs/directdeposit",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors) {

            // get JS selectors
            var directDepositTab = $.js(jsSelectors.directDepositTab);

            var directDepositBankSelectList = directDepositTab.js(jsSelectors.directDepositBankSelectList);
            var accountNumberInput = directDepositTab.js(jsSelectors.accountNumberInput);

            // Customize jquery validation to conditionally apply validations
            _setupCustomValidation();

            // Based on selection, toggle validation
            directDepositBankSelectList.change(toggleValidation);

            // Based on if an account number is being provided, toggle validation
            accountNumberInput.on('input', toggleValidation);

            // Based on control values, toggle validation
            function toggleValidation() {
                _updateValidationScope(directDepositBankSelectList.val() != '' || accountNumberInput.val() != '');
            }

            // Update the data-val property of the directDepositTab element so
            // the custom jquery validation "ignore" function can look at it
            function _updateValidationScope(validate) {
                directDepositTab.data("val", validate);

                // Set the html attribute for data-val so css can see it
                directDepositTab.attr('data-val', validate);
            }

            // Customize jqueryvalidation to possibly skip client-side validations if
            // the validationScope is configured to not validate its children
            function _setupCustomValidation() {
                var currentIgnoreFunction = $.validator.defaults.ignore;

                var overrides = {
                    ignore: function (index, element) {

                        var result = false;

                        if (currentIgnoreFunction) {
                            result = currentIgnoreFunction(index, element);
                        }

                        if (!result) {

                            var validationScope = $(element).closestjs(jsSelectors.directDepositTab, { required: false });
                            if (validationScope.length > 0) {
                                result = validationScope.data("val") == false
                            }
                        }

                        return result;
                    }
                }

                // merge our overrides into the current active defaults
                $.validator.setDefaults(overrides);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);